module.exports = __webpack_public_path__ + "static/media/eofy_everyday_digital.49eda51f.webp";